import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'

const Indexacion = () => {
  return (
    <div class="listado">
        <h2 className='tituloAccion'>Indexación</h2>
        <TableContainer>
            <Table sx={{minWidth: 500}} size="small" >
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell><a href=''>Por Ahora Nada</a></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    </div>
  )
}

export default Indexacion